<div class="container">
    <form [formGroup]="form">
        <div class="mb-3">
            <div class="row ms-5 mt-5">
                <label class="col-md-3 required-label"><strong>Audit Status:</strong></label>
                <div class="col-md-8">
                    <select class="form-control"
                            [formControl]="auditState"
                            formControlName="auditState"
                            (change)="onSelectedAuditState($event)">
                        <option *ngFor="let state of auditStates"
                                [value]="state.id">
                            {{ state.text }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row ms-5 mt-5" [class.has-danger]="!auditNote?.valid && auditNote?.touched">
                <label class="col-md-3 required-label"><strong>Note:</strong></label>
                <div class="col-md-8">
                <textarea [formControl]="auditNote"
                          (change)="onChangeAuditNote()"
                          formControlName="auditNote"
                          name="auditNote"
                          cols="30"
                          rows="5"
                          maxlength="512"
                          class="form-control"></textarea>
                    <small class="text-muted">{{auditNote?.value?.length || 0}}/512</small>
                    <div *ngIf="auditNote?.hasError('required') && auditNote?.touched"
                         class="alert alert-danger mt-2">
                        Comment is required
                    </div>
                </div>
            </div>

            <div class="row ms-5 mt-5" *ngIf="isFailedAuditState$ | async"
                 [class.has-danger]="denialReason?.invalid && denialReason?.touched">
                <label class="col-md-3 required-label"><strong>Denial&nbsp;Reason:</strong></label>
                <div class="col-md-8">
                    <select [formControl]="denialReason" class="form-control">
                        <option [ngValue]="null" disabled>Choose a Denial Reason</option>
                        <option *ngFor="let option of ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS"
                                [ngValue]="option.value">{{ option.label }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row ms-5 mt-5"
                 *ngIf="(isFailedAuditState$ | async) && denialReason.value?.toString() === 'Other'"
                 [class.has-danger]="otherDenialReason?.invalid && otherDenialReason?.touched">

                <label class="col-md-3 required-label"><strong>Explanation:</strong></label>
                <div class="col-md-8">
                    <input type="text" class="form-control" [formControl]="otherDenialReason" maxlength="128">
                    <small class="text-muted">{{otherDenialReason?.value?.length || 0}}/128</small>
                    <div *ngIf="auditNote?.hasError('required') && auditNote?.touched"
                         class="alert alert-danger mt-5">
                        Explanation is required
                    </div>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-secondary m-2 pull-right" [disabled]="isProcessing" (click)="onClickCancelAuditState()">Cancel
        </button>
        <button type="button" class="btn btn-primary m-2 px-1 pull-right" [disabled]="isProcessing" (click)="onClickConfirmAuditState()">Confirm
        </button>
    </form>
</div>
